<template>
    <div class="frameSec">
       <AddNewCard />
    </div>
</template>

<script>
    import AddNewCard from '../../../components/Settings/AddNewCard';

    export default {
        computed : {

        },
        components: {
            AddNewCard
        }
    }
</script>
